import temperature from './svg/Card_Temperature_fr.svg';
import twelveweek from './svg/Card_TwelveWeek_fr.svg';

export default [
  temperature,
  twelveweek,
];
